import { ReactSVG } from 'react-svg';
import { Cross } from '../../assets/images';
import { CancelText, ConfirmText, SubmitText } from '../constants';
import { modalProps } from './modal.props';

function Modal({
  onClose,
  onCloseIcon,
  onConfirm,
  heading,
  subHeading,
  children,
  onSubmit,
  disableButton,
}: modalProps) {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white relative min-w-[400px] pt-[60px] pb-[30px] px-[30px] rounded-lg">
        {(onClose || onCloseIcon) && (
          <ReactSVG
            src={Cross}
            className="cursor-pointer absolute top-[30px] right-[20px]"
            onClick={() => {
              onClose?.();
              onCloseIcon?.();
            }}
          />
        )}
        <h2 className="text-[24px] leading-[31.2px] font-bold text-center mb-[12px]">{heading}</h2>
        <p className="text-[16px] leading-[45px] text-center whitespace-pre-line mb-[8px]">
          {subHeading}
        </p>
        {children}
        <div className="text-center">
          {onConfirm && (
            <button
              type="button"
              className={`cursor-pointer  bg-blue-500 text-white text-[15px] font-bold leading-6 min-w-[150px] rounded-3xl py-[10px] px-0 `}
              onClick={onConfirm}
              disabled={disableButton}
            >
              {ConfirmText}
            </button>
          )}
          {onSubmit && (
            <button
              type="button"
              className={`cursor-pointer text-[15px]  bg-blue-500 text-white font-bold leading-6 min-w-[150px] rounded-3xl py-[10px] px-0
              `}
              onClick={onSubmit}
              disabled={disableButton}
            >
              {SubmitText}
            </button>
          )}
          {onClose && (
            <button
              type="button"
              className="pt-[10px] pb-[10px] rounded-3xl cursor-pointer text-[15px] font-[700] leading-[24px] min-w-[150px] border border-gray-400 text-[#949494] bg-[#f6f6fd]"
              onClick={onClose}
            >
              {CancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;
